import React, { useState } from "react"
import { Link } from "react-scroll"
import { HiMenu, HiX } from "react-icons/hi"

const LINKS = [
  { to: "about", label: "About" },
  { to: "experience", label: "Experience" },
  { to: "skills", label: "Skills" },
  { to: "project", label: "Projects" },
  { to: "contact", label: "Contact" },
]

export default function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <nav className="fixed top-0 w-full z-50 bg-ink/85 backdrop-blur-md border-b border-lineSoft font-mono">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="home" smooth={true} duration={500} className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-8 h-8 border border-amber flex items-center justify-center text-amber text-xs font-semibold">
            DK
          </span>
          <span className="text-sm tracking-wide hidden sm:inline">DINESH B. KHAWAS</span>
        </Link>

        <ul className="hidden md:flex items-center gap-7 text-xs tracking-widest">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                smooth={true}
                duration={500}
                offset={-64}
                className="text-muted hover:text-white transition-colors cursor-pointer"
              >
                {l.label.toUpperCase()}
              </Link>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-2 text-[11px] tracking-wide text-mint border border-mintDim px-2.5 py-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-mint" />
          OPEN TO WORK
        </div>

        <button
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen(!open)}
          className="md:hidden text-white p-2"
        >
          {open ? <HiX size={22} /> : <HiMenu size={22} />}
        </button>
      </div>

      {open && (
        <ul className="md:hidden flex flex-col gap-1 px-6 pb-5 text-sm tracking-widest border-t border-lineSoft">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                smooth={true}
                duration={500}
                offset={-64}
                onClick={() => setOpen(false)}
                className="block py-3 text-muted hover:text-white transition-colors cursor-pointer"
              >
                {l.label.toUpperCase()}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </nav>
  )
}
